import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export const FiltersWrapper = styled.div`
  background: #ffffff;
  border-radius: 5px;
  padding: 20px 25px 10px 25px;
  box-shadow: 0px 10px 30px #00000029;
  width: 100%;
  margin-bottom: 70px;
  position: absolute;
  top: calc(100% - 60px);

  ${media.md`
    position: static;
    width: auto;
    padding: 5px 15px 15px 15px;
  `}
`;
